import { useState } from "react";

import { MenuAnchorEl, ROUTES } from "../../../../../../../../shared";
import { MORE_ACTIONS_MENU_SIZES } from "../../../../../../../../shared/components/buttons/types";
import { EmailTransferObjectDto } from "../../../../../../types";
import SingleDetailsAcordionItem from "../../../AccordionDetailsCard/components/SingleDetailsAcordionItem";
import SingleEmailTransferContent from "../SingleEmailTransferContent/SingleEmailTransferContent";

import EmailTransferActions from "./EmailTransferActions/EmailTransferActions";

interface SingleEmailTransferItemProps {
  companyId: string;
  card: EmailTransferObjectDto;
  totalCount: number;
  index: number;
}

const SingleEmailTransferItem = ({
  companyId,
  card,
  totalCount,
  index,
}: SingleEmailTransferItemProps) => {
  const [isActionsOpen, setIsActionsOpen] = useState<MenuAnchorEl>(null);

  return (
    <SingleDetailsAcordionItem
      route={ROUTES.Companies}
      title={card.email}
      totalCount={totalCount}
      index={index}
      collapsable
      anchorEl={isActionsOpen}
      setIsActionsOpen={setIsActionsOpen}
      titleInlineActions={
        <EmailTransferActions
          card={card}
          companyId={companyId}
          onActionsMenu={setIsActionsOpen}
        />
      }
      menuWidth={MORE_ACTIONS_MENU_SIZES.Small}
    >
      <SingleEmailTransferContent card={card} />
    </SingleDetailsAcordionItem>
  );
};

export default SingleEmailTransferItem;
